import { useEffect, useState } from "react";

/**
 * Second, independent theme axis alongside the `dark` class: the ACCENT
 * PALETTE. Sidebar.tsx and mobileSideBar.tsx each maintain their own
 * `darkMode` state + effect independently (existing pattern, not touched
 * here) — this hook exists so the new palette flag isn't copy-pasted a
 * third/fourth time; both sidebars call this one hook instead.
 *
 * Sets/removes `data-vi-palette="teal"` on <html> (absence = "blue", the
 * default) — theme-tokens.css's four value blocks key off this attribute
 * combined with `.dark`, completely independently of it.
 */
export type PaletteName = "blue" | "teal";

const STORAGE_KEY = "vi-palette";

export const usePalette = () => {
  const [palette, setPalette] = useState<PaletteName>(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved === "teal" ? "teal" : "blue";
  });

  useEffect(() => {
    if (palette === "teal") {
      document.documentElement.setAttribute("data-vi-palette", "teal");
    } else {
      document.documentElement.removeAttribute("data-vi-palette");
    }
    localStorage.setItem(STORAGE_KEY, palette);
  }, [palette]);

  const togglePalette = () =>
    setPalette((prev) => (prev === "teal" ? "blue" : "teal"));

  return { palette, togglePalette };
};
